import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setMainLoading, setPageTitle } from "../../Store/reducers/Common";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { ConvertErrorArrayToString, integerTest } from "../../Services/Common";
import { PostAxios, responseCatchFunc } from "../../Services/RequestService";
import { setToastData } from "../../Store/reducers/Toast";

const AddMember = () => {
    const dispatch = useDispatch();
    const { accessToken, userData } = useSelector(state => state.user);
    const [orgList, setOrgList] = useState([]);
    const [divList, setDivList] = useState([]);
    const [rolesList, setRolesList] = useState([]);
    const [capsList, setCapsList] = useState([]);
    useEffect(() => {
        dispatch(setMainLoading(true));
        dispatch(setPageTitle('Add Member'));
        let promiseArray = [];
        if (userData.role_slug === "super_admin") {
            promiseArray.push(PostAxios(`masters/organization`, { page: 1, perPage: 1000 }, accessToken));
        }
        if (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") {
            promiseArray.push(PostAxios(`masters/division-list`, { org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id, page: 1, perPage: 1000 }, accessToken));
            promiseArray.push(PostAxios(`masters/roles-capabilities-list`, {}, accessToken));
        }
        if (promiseArray.length > 0) {
            Promise.all(promiseArray)
                .then((response) => {
                    let responseCaps = (response?.[1]?.config?.url === "masters/roles-capabilities-list")?response[1].data:response[2].data;
                    console.log(responseCaps);
                    if (response[0].config.url === "masters/organization") {
                        if (response[0].data.status === "1") {
                            setOrgList(response[0].data.data);
                        }
                    }
                    else {
                        if (response[0].data.status === "1") {
                            setDivList(response[0].data.data);
                        }
                    }
                    if (response?.[1]?.config?.url === "masters/division-list") {
                        if (response[1].data.status === "1") {
                            setDivList(response[1].data.data);
                        }
                    }
                    //if (response?.[2]?.config?.url === "masters/roles-capabilities-list") {
                        if (responseCaps.status === "1") {
                            setRolesList(responseCaps.data.roles_list);
                            setCapsList(responseCaps.data.capability_list);
                        }
                    //}
                })
                .catch(err => {
                    console.log(err);
                }).finally(() => {
                    dispatch(setMainLoading(false));
                })
        }
    }, [accessToken, dispatch])
    return (
        <div className="main-form-sec">
            <Formik
                initialValues={{
                    org_id: parseInt(userData.org_id) > 0 ? parseInt(userData.org_id) : 0,
                    div_id: userData.role_slug === "super_admin" ? 0 : userData.user_div,
                    user_its: '',
                    first_name: '',
                    last_name: '',
                    user_mobile: '',
                    role_id: 0,
                    capability_list: []
                }}
                validate={values => {
                    const errors = {};
                    if (parseInt(values.org_id) < 1) { errors.org_id = "Organization ID should not be empty"; }
                    if (parseInt(values.div_id) < 1) { errors.div_id = "Please choose Mohallah of Member"; }
                    if (parseInt(values.role_id) < 1) { errors.role_id = "Please choose Role for Member"; }
                    if (!values.user_its) { errors.user_its = "ITS is required"; }
                    else if (values.user_its.length !== 8 || !integerTest(values.user_its)) { errors.user_its = "ITS should be valid"; }
                    if (!values.first_name) { errors.first_name = "First name is required"; }
                    if (!values.last_name) { errors.last_name = "Last name is required"; }
                    if (!values.user_mobile) { errors.user_mobile = 'Mobile number is required'; }
                    else if (values.user_mobile.length !== 10) { errors.user_mobile = 'Mobile number length should be 10'; }
                    else if (!integerTest(values.user_mobile)) { errors.user_mobile = 'Please enter valid mobile number'; }
                    return errors;
                }}
                onSubmit={(values, { setSubmitting,resetForm }) => {
                    dispatch(setMainLoading(true));
                    setSubmitting(true);
                    PostAxios(`users/add-user`, {
                        org_id: values.org_id,
                        div_id: values.div_id,
                        user_its: values.user_its,
                        first_name: values.first_name,
                        last_name: values.last_name,
                        user_mobile: values.user_mobile,
                        role_id: values.role_id,
                        capability_list: JSON.stringify(values.capability_list)
                    },accessToken)
                    .then(({data})=>{
                        if(data.status === "1"){
                            dispatch(setToastData({ message: `${data.message} `, isHtml: true, type: 'success', showCloseBtn: true }))
                            resetForm();
                        }
                        else{
                            dispatch(setToastData({ message: (data.errors)?ConvertErrorArrayToString(data.errors):data.message, isHtml: true, type: 'error', showCloseBtn: true }))
                        }
                    })
                    .catch(err=>{
                        responseCatchFunc(dispatch,err);
                    })
                    .finally(()=>{
                        dispatch(setMainLoading(false));
                        setSubmitting(false);
                    })
                }}
            >
                {({ errors, touched, isSubmitting, handleChange, setFieldValue, values }) => (
                    <Form>
                        <div className="form-sec">
                            {
                                userData.role_slug === "super_admin" &&
                                <div className={`form-field-group w-50 ${(errors.org_id && touched.org_id) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="org_id">Organization</label>
                                    </div>
                                    <div className="w-50">
                                        <label className="select-input-outer select-100">
                                            <Field name="org_id" as="select" className="select-input" onChange={(e) => {
                                                if (e.target.value === "0") {
                                                    setFieldValue('div_id', 0);
                                                }
                                                handleChange(e)
                                            }}>
                                                <option value="0">Choose Organization</option>
                                                {
                                                    orgList.length > 0 && orgList.map((item, index) => {
                                                        return <option value={item.ID} key={`org-list-${item.ID}`}>{item.short_name}</option>
                                                    })
                                                }
                                            </Field>
                                        </label>
                                        <ErrorMessage component="span" name="org_id" className="error-label" />
                                    </div>
                                </div>
                            }
                            {
                                (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                                <div className={`form-field-group w-50 ${(errors.div_id && touched.div_id) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="div_id">Mohallah</label>
                                    </div>
                                    <div className="w-50">
                                        <label className="select-input-outer select-100">
                                            <Field name="div_id" as="select" className="select-input" >
                                                <option value="0">Choose Mohallah</option>
                                                {
                                                    divList.length > 0 && divList.map((item, index) => {
                                                        if (parseInt(item.org_id) === parseInt(values.org_id)) {
                                                            return <option value={item.ID} key={`div-list-${item.ID}-${index}`}>{item.division_name} {`(${item.division_number})`}</option>
                                                        }
                                                        return null;
                                                    })
                                                }
                                            </Field>
                                        </label>
                                        <ErrorMessage component="span" name="div_id" className="error-label" />
                                    </div>
                                </div>
                            }
                            <div className={`form-field-group w-50 ${(errors.user_its && touched.user_its) ? 'error-input' : ''}`}>
                                <div className="w-50">
                                    <label htmlFor="user_its">ITS</label>
                                </div>
                                <div className="w-50 input-area">
                                    <Field type="text" className="form-input" placeholder="ITS" name='user_its' />
                                    <ErrorMessage component="span" name="user_its" className="error-label" />
                                </div>
                            </div>
                            <div className={`form-field-group w-50 ${(errors.first_name && touched.first_name) ? 'error-input' : ''}`}>
                                <div className="w-50">
                                    <label htmlFor="first_name">First Name</label>
                                </div>
                                <div className="w-50 input-area">
                                    <Field type="text" className="form-input" placeholder="First Name" name='first_name' />
                                    <ErrorMessage component="span" name="first_name" className="error-label" />
                                </div>
                            </div>
                            <div className={`form-field-group w-50 ${(errors.last_name && touched.last_name) ? 'error-input' : ''}`}>
                                <div className="w-50">
                                    <label htmlFor="last_name">Last Name</label>
                                </div>
                                <div className="w-50 input-area">
                                    <Field type="text" className="form-input" placeholder="Last Name" name='last_name' />
                                    <ErrorMessage component="span" name="last_name" className="error-label" />
                                </div>
                            </div>
                            <div className={`form-field-group w-50 ${(errors.user_mobile && touched.user_mobile) ? 'error-input' : ''}`}>
                                <div className="w-50">
                                    <label htmlFor="user_mobile">Mobile</label>
                                </div>
                                <div className="w-50 input-area">
                                    <Field type="text" className="form-input" placeholder="Mobile" name='user_mobile' />
                                    <ErrorMessage component="span" name="user_mobile" className="error-label" />
                                </div>
                            </div>
                            <div className={`form-field-group w-50 ${(errors.role_id && touched.role_id) ? 'error-input' : ''}`}>
                                <div className="w-50">
                                    <label htmlFor="role_id">Role</label>
                                </div>
                                <div className="w-50">
                                    <label className="select-input-outer select-100">
                                        <Field name="role_id" as="select" className="select-input" >
                                            <option value="0">Choose Role</option>
                                            {
                                                rolesList.length > 0 && rolesList.map((item, index) => {
                                                    if (item.role_slug !== "super_admin") {
                                                        return <option value={item.id} key={`roles-list-${item.id}-${index}`}>{item.role_name}</option>
                                                    }
                                                    return null;
                                                })
                                            }
                                        </Field>
                                    </label>
                                    <ErrorMessage component="span" name="role_id" className="error-label" />
                                </div>
                            </div>
                            <div className="btm-right-btn justify-content-center my-3">
                                <button className="btn-blue btn" type="submit" disabled={isSubmitting}>Add Member</button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default AddMember;